import { graphql } from "@/gql";
import { AllergiesKind } from "@/gql/graphql";

import { useFragment } from "./useFragment";

const useClientAllergiesFragment = graphql(`
  fragment UseClientAllergies on Client {
    id
    dietaryHistory {
      id
      allergies2
    }
  }
`);

export default function useClientAllergies(clientId: string): AllergiesKind[] {
  const [client] = useFragment(
    useClientAllergiesFragment,
    `Client:${clientId}`
  );
  return client?.dietaryHistory?.allergies2 ?? [];
}
